<template>
  <div>
    <nav id="sidebar" class="d-flex flex-wrap justify-content-center align-items-center">
      <div class="slide-login not-logged-in" v-if="isLoggedIn === false">
        <h4>You're not signed in</h4>
        <div class="log-buttons">
          <router-link to="/" class="btn btn-primary" @click.native="toggleSidebar">Login</router-link>
          <p>
            <span>or</span>
          </p>
          <router-link to="/signup" class="btn btn-default" @click.native="toggleSidebar">Sign up</router-link>
        </div>
        <a class="mainsite-link" href="#">Main Site</a>
      </div>

      <div class="slide-login logged-in" v-else>
        <div class="user-details">
          <div class="profile-img">
            <div v-if="userDetails.profileImage">
              <img :src="userDetails.profileImage" class="profile-image" />
            </div>
            <div v-else>
              <img src="../../../public/assets/images/defaultUser.png" />
              <!-- <i class="fa fa-user fa-7x" style="color: #736969;"></i> -->
            </div>
          </div>
          <h4>{{ userDetails.name }}</h4>
          <a>{{ userDetails.email }}</a>

          <p class="event-count" v-if="userDetails.remainingEventsCount.isOnTrial">
            Unlimited events till
            <strong>{{ userDetails.trialPeriodEndAt | moment("Do MMM YYYY")}}</strong>
          </p>
          <p class="event-count" v-else>
            <strong>{{ userDetails.remainingEventsCount.freeEventsRemaining + userDetails.remainingEventsCount.purchasedEventsRemaining }}</strong> Available Events
          </p>
        </div>
        <div class="offset-menu">
          <ul>
            <!-- <li>
              <a href="#" @click="changePassword">Change Password</a>
            </li>-->
            <li>
              <router-link to="/dashboard">Wish list</router-link>
            </li>
            <li>
              <a @click="myAccount">My Account</a>
            </li>

            <li>
              <router-link to="/purchasePacks">Purchase Packs</router-link>
            </li>
            <li>
              <router-link to="/paymentHistory">Payment history</router-link>
            </li>
            <li @click="toggleSidebar()">
              <a href="#" @click="archivedWishlist()">Archived events</a>
            </li>
            <li>
              <a @click="logout">Log out</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="download-link">
        <a target="_blank" href="https://apps.apple.com/au/app/white-bow-gift-registry/id1494432391">
          <img src="../../../public/assets/images/appstore.png" />
        </a>
        <a href="#" @click="showPrivacyPolicy">Privacy policy</a>
      </div>
    </nav>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import {
  LOGOUT,
  LOGIN,
  SET_USER_LOGGED,
  SAVE_TOKEN,
  REMOVE_USER_DETAILS
} from "../../store/auth/action.type";
import $ from "jquery";

export default {
  data() {
    return {
      isLoggedIn: false
    };
  },
  computed: {
    ...mapGetters(["isUserLoggedIn"]),
    ...mapState({
      userDetails: state => state.auth.userDetails
    })
  },

  mounted() {
    if (
      localStorage.getItem(
        "GiftRegistryAccessToken" + process.env.VUE_APP_ACCESS_TOKEN_NAME
      )
    ) {
      this.isLoggedIn = true;
    }
  },

  methods: {
    logout(e) {
      localStorage.clear();
      this.toggleSidebar();
      this.$store.dispatch(SET_USER_LOGGED, false);
      this.$store.dispatch(REMOVE_USER_DETAILS);
      this.$router.push({ name: "Login" });
    },

    toggleSidebar(e) {
      // let collapse = document.getElementById("sidebarCollapse"); //call function of close button in sidebar
      // collapse.click(); //to hide sidebar on clicking any button
      $("#sidebar").removeClass("active");
      $("body").removeClass("active");

      $(".overlay").remove();

      $("#sidebarCollapse").removeClass("active");
    },
    archivedWishlist() {
      this.toggleSidebar();
      this.$router.push({ path: "/archived" });
    },

    changePassword(e) {
      this.toggleSidebar();
      this.$router.push({ path: "/changePassword" });
    },

    myAccount(e) {
      this.toggleSidebar();
      this.$router.push({ path: "/accountDetails" });
    },

    showPrivacyPolicy(e) {
      this.toggleSidebar();
      this.$router.push({ path: "/privacyPolicy" });
    }
  }
};
</script>
<style scoped>
.profile-image {
  border-radius: 50%;
  height: 100%;
}
</style>>
